export default __webpack_public_path__ + "static/media/tranings_no_image_2.e28f9cc8.svg";